import React from "react";
import { Link } from "react-router-dom";

interface Props {
	crumb: { name: string; link?: string }[];
	className?: string;
	style?: { [key: string]: string | number | null };
}

export default function Breadcrumb({ crumb, className, style }: Props) {
	const crumbLinks = [...crumb];

	// Remove the last item in the crumb
	// because it doesn't need a link
	crumbLinks.splice(crumb.length - 1, 1);

	return (
		<nav
			style={style}
			aria-label="breadcrumb"
			className={`breadcrumb-container ${className}`}>
			<ol className="breadcrumb">
				{crumbLinks.map(({ name, link }) => {
					return (
						<li className="breadcrumb-item" key={name}>
							{link ? <Link to={link}>{name}</Link> : name}
						</li>
					);
				})}
				<li className="breadcrumb-item active" aria-current="page">
					{crumb[crumb.length - 1].name}
				</li>
			</ol>
		</nav>
	);
}
